// TS-side palette values — the subset of the brand palette that JS actually
// needs: the antd `ConfigProvider` (literal hex, since antd derives hover/active
// variants from the base) and inline / third-party styles that can't use a
// Tailwind class (Stripe). All className colours live as `--color-*` tokens in
// the `@theme` block of index.css. See .interface-design/system.md for the full
// palette and intent.

// Neutral ink ramp (text) — mapped into antd colorText* in main.tsx
export const ink = '#141414'
export const inkSecondary = '#5b6168'
export const inkTertiary = '#8a9099'
export const inkQuaternary = '#bfc4cb'

// Brand
export const colorPrimary = '#6996FE' // periwinkle — antd colorPrimary/colorLink

// Functional
export const error = '#ff4d4f' // antd's danger red — Stripe invalid field

// Surfaces
export const canvas = '#fbfbfc' // antd colorBgLayout
